<template>
  <!--查看-->
  <div>
    <el-form :model="formData" :rules="rules" v-loading="saveLoading" ref="integrateAddForm" label-position="left" :label-width="'100px'" class="form-horizontal detail-form paddingTopDetail employeeEditDetail" >
      <div class="subTitle">订单信息</div>
      <el-form-item prop="ddbm" label="订单编号：" class="rowItem">
        {{formData.orderCode}}
      </el-form-item>
      <div class="roomInfo">
        <div class="roomName">{{formData.roomName}}</div>
        <div>
          <span>{{formData.startTime}}</span>
          <span>至</span>
          <span>{{formData.endTime}}</span>
        </div>
        <div>
          <span>共</span>
          <span>{{formData.nights}}</span>
          <span>{{detailData.orderType==1?'晚':'时'}}</span>
        </div>
      </div>
      <div style="text-align: center;padding: 20px;width: 100%;">
        <el-button class="submit-btn" @click="handleSave()" >确定</el-button>
        <el-button class="cancel-btn" @click="handleCancel">取消</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
  import Vue from 'vue';
  import {
    mapActions
  } from 'vuex'
  import moment from 'moment'
  import orderMix from './mixin.js'
  export default {
    components: {},
    mixins: [orderMix],
    name: "orderCancelModel",
      props:{
        selOptions: {
          type: Object,
          default:{},
        },
        detailModal:{
          type:Boolean,
          default:''
        },
        detailData:{
          type:Object,
          default:{}
        },
        detailType:{
          type:String,
          default:'show'
        }
      },
      data(){
        let detailKeys = ['orderCode','startTime','endTime','nights']

        let formData = {}
        detailKeys.map((key)=>{
          formData[key] = ''
        })
        return{
          isValid:true,
          showType:'',
          saveLoading:false,
          detailKeys:detailKeys,

          rules:{
          },

          wyfdzSsxqdm_provinceDicts:[],
          wyfdzSsxqdm_cityDicts:[],
          wyfdzSsxqdm_areaDicts:[],
          areaCodes:{},
          formData:formData
        }
    },
    created(){
    },
    mounted(){
      this.showType = this.detailType
    },
    watch:{
      detailType(val){
        this.showType = val
      },
      detailModal:{
        immediate: true,
        handler: function(to){
          if(to===false){
            return false
          }
          this.formData = {...this.detailData}
          //已预订和已登记的记录拟入住和拟离开时间；已入住的则是记录实际的入住和拟离开时间；已完成的 是真实的入住时间和离开时间
          //1-已预订，2-已登记，3-已入住，4-已完成，5-已取消，6-已失效
          if(this.detailData.orderState==3){
            this.formData.startTime = this.detailData.actualCheckInTime
            this.formData.endTime = this.detailData.proposedCheckOutTime
          }else if(this.detailData.orderState==4){
            this.formData.startTime = this.detailData.actualCheckInTime
            this.formData.endTime = this.detailData.actualCheckOutTime
          }else{
            this.formData.startTime = this.detailData.proposedCheckInTime
            this.formData.endTime = this.detailData.proposedCheckOutTime
          }
          
          this.formData.nights = this.getDiffTime(this.formData.startTime,this.formData.endTime,this.detailData.orderType)
        }
      }
    },
    methods:{
      ...mapActions([
        'alertToggle',
        'fetchData'
      ]),
      //保存与发布
      handleSave(type){
        //this.saveLoading = true
        //全日房订单，若提前退房时间大于拟离店时间2小时以上
        let start = moment().format('YYYY-MM-DD HH:mm:ss')
        let end = this.detailData.proposedCheckOutTime
        let timeDiff = moment(end).diff(moment(start),'seconds')
        
        if(this.detailData.orderType+''=='1' && timeDiff>=2*60*60){
          this.$confirm('还未到退房时间，确认是否退房？', { type: 'warning' })
          .then(() => {
            this.doSave()
          })
          .catch(() => false)
        }else{
          this.doSave()
        }
      },
      //退房
      doSave(){
        let url = 'SAAS.ORDER_EDIT_CHECKOUT'
        let params = {id:this.detailData.id}

        this.fetchData({url:url, method: 'post', params:params,timeout:0, isLoading:false, flag:true}).then((res)=>{
          if(res.code==200){
            this.$message.success(res.msg||'操作成功！')
            this.$emit('submitSuccess')
          }else{
            this.$message.error(res.msg||'操作失败！')
          }
          this.saveLoading = false
        }).catch((err)=>{
          this.$message.error('操作失败！')
          this.saveLoading = false
        }).finally (()=>{
          this.saveLoading = false
        })
      },
      handleCancel(){
        this.$emit('closeModel')
      },
    },
  }
</script>

<style lang="less" scoped>
  .employeeEditDetail{
    display: flex;
    flex-wrap: wrap;
    margin: 0 auto;
    width: 90% !important;
  }
  .employeeEditDetail .el-form-item{
    width: 50% !important;
    .el-select{
      width: 100%;
    }
  }
  .employeeEditDetail .el-form-item.rowItem {
    width: 100% !important;
  }
  .employeeEditDetail .detailContent{
    padding: 0px;
  }
  .sentContent{
    margin: 20px;
    padding: 10px;
    border: 1px solid rgba(38, 118, 165, 1) ;
  }
  .sentContentTitle{
    text-align: center;
  }

  .roomInfo{
    display: flex;
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 50px;
    .roomName{
      min-width: 90px;
    }
    div{
      margin-right: 10px;
    }
    span{
      padding: 2px;
    }
  }
  .subTitle{
    font-size: 12px;
    margin-bottom: 32px;
  }
</style>
<style lang="less" >
  .employeeEditDetail .w-e-text-container{
    border:1px solid #2676a5 !important;
  }
</style>

